import React from 'react';
import { Send } from 'lucide-react';

const EmptyState = ({ c, styles, t }) => {
  return (
    <div style={styles.emptyState}>
      <div style={styles.emptyStateContent}>
        <div style={styles.emptyStateIcon}>
          <Send style={{ width: '50px', height: '50px', color: '#ffffff' }} />
        </div>
        <h3 style={styles.emptyStateTitle}>{t.yourMessages}</h3>
        <p style={styles.emptyStateText}>{t.selectPerson}</p>
      </div>
    </div>
  );
};

export default EmptyState;